import { render, staticRenderFns } from "./ModalApproveDeniedOnboarding.vue?vue&type=template&id=72746f85&scoped=true&"
import script from "./ModalApproveDeniedOnboarding.vue?vue&type=script&lang=ts&"
export * from "./ModalApproveDeniedOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./ModalApproveDeniedOnboarding.vue?vue&type=style&index=0&id=72746f85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72746f85",
  null
  
)

export default component.exports